import { IconButton } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";

const TutorialButton = ({ setShowTutorial }) => {
  return (
    <IconButton
      color="inherit"
      onClick={() => setShowTutorial(true)}
      aria-label="tutorial"
    >
      <MenuBookIcon />
    </IconButton>
  );
};

export default TutorialButton;
